import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const AgentCardPhoneIcon = ({ className, onClick }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className} onClick={onClick}>
      <g clipPath="url(#agent-card-phone-clip)">
        <path opacity="0.3" d="M12.6668 11.6466C12.0802 11.5999 11.5002 11.4999 10.9335 11.3466L10.1402 12.1399C10.9402 12.4133 11.7935 12.5866 12.6735 12.6399V11.6466H12.6668ZM3.35352 3.33325C3.41352 4.21325 3.58685 5.05992 3.85352 5.86659L4.65352 5.06659C4.50018 4.50659 4.40018 3.92659 4.36018 3.33325H3.35352Z" fill="#323232"/>
        <path d="M6.04667 5.04667C5.8 4.3 5.66667 3.5 5.66667 2.66667C5.66667 2.3 5.36667 2 5 2H2.66667C2.3 2 2 2.3 2 2.66667C2 8.92667 7.07333 14 13.3333 14C13.7 14 14 13.7 14 13.3333V11.0067C14 10.64 13.7 10.34 13.3333 10.34C12.5067 10.34 11.7 10.2067 10.9533 9.96C10.8867 9.93333 10.8133 9.92667 10.7467 9.92667C10.5733 9.92667 10.4067 9.99333 10.2733 10.12L8.80667 11.5867C6.92 10.62 5.37333 9.08 4.41333 7.19333L5.88 5.72667C6.06667 5.54 6.12 5.28 6.04667 5.04667ZM10.9333 11.3467C11.5 11.5067 12.08 11.6067 12.6667 11.6467V12.64C11.7867 12.58 10.94 12.4067 10.1333 12.14L10.9333 11.3467ZM3.86 5.86667C3.58667 5.06 3.41333 4.21333 3.35333 3.33333H4.35333C4.4 3.92667 4.5 4.50667 4.66 5.06L3.86 5.86667Z" fill="#323232"/>
      </g>
      <defs>
        <clipPath id="agent-card-phone-clip">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default AgentCardPhoneIcon;
